import React, { useEffect } from "react";
import "./assets/css/app.min.css";
import { useDispatch, useSelector } from "react-redux";
import { logingFromCRM, iframeEvent } from "./action/manufacturers_auth/login.action.js";
import { geDefaultBuildingData, geDefaultBuildingDataForKlink, handleShowsummarymodal, handleShowfeedback, handleMobileDraw, handleShowBookDemo, getSelectedTabstate } from "./action/index.js";
import { handleCommonModal } from "./action/quote_order/leadcustomer.action.js";
import ControlPanel from "./Components/ControlPanel/ControlPanel";
import StateChange from "./Components/StateChange/StateChange";
import { getPrepareDefaultBuilding } from "./Intel/defaultBuilding/defaultBuilding.js";
import MaintenanceWindow from "./Components/MaintenanceWindow/MaintenanceWindow";
import Header from "./Components/Header/Header";
import MobilePriceSummary from "./Components/MobilePriceSummary/MobilePriceSummary";
import PweredBy from "./assets/images/senseiupdatelogo.svg";
import { const_var, params } from "./redux/reducers/reducer";
import CupolaEditBox from "./Components/ControlPanel/Cupola/CupolaEditBox";
import UserTour from "./Components/ControlPanel/Common/UserTour";
import ReportIssueComp from "./Components/ReportIssue/ReportIssueComp";
import DoorWindowEditComponent from "./Components/ControlPanel/DoorWindowEditBox/index.js";
import NewCanvas from "./Components/Canvas/NewCanvas.js";
import MobileHeader from "./Components/Header/MobileHeader.js";
import MobileFooter from "./Components/MobileFooter/MobileFooter.js";
import DeviceCaptureInfo from "./Components/ControlPanel/Common/DeviceCaptureInfo.js";
import Redo from "./Components/Redo/Redo.js";
import logoSvg from "./assets/images/sensei-new-logo.svg";
import AnimButton from "./Components/Button/AnimButton.js";
import BookADemoTooltip from "./Components/ControlPanel/Common/BookADemoTooltip.js";
import TotalDiscount from "./Components/ControlPanel/Common/DepositOrder/TotalDiscount.js";
import Discounts from "./Components/Header/Discounts.js";
import {  prepareLoftDropdown } from "./redux/reducers/utils.js";
import { initiallyLoadTextures } from "./redux/reducers/utils.js";
import Announcement from "./Components/Header/Announcement.js";
import DiscountPopUp from "./Components/Modals/AlertBox/DiscountPopUp.js";
import TopBanner from "./Components/Header/TopBanner.js";
import { getDealerStateList } from "./action/manufacturers_auth/manufacture.action.js";
import { initIntelDefaultlParams } from "./Intel/defaultBuilding/defaultbuilding.helper.js";

let checkactivelogin = false;
const App = () => {
	const { const_var, showDiscountBanners, isMobileDraw, isShowBookDemo, selectedTabKey } = useSelector((state) => state.reducer);
	const dispatch = useDispatch();
	const initApp = () => {
		initIntelDefaultlParams(const_var);
		const root = document.documentElement;
		const primaryColor = getComputedStyle(root).getPropertyValue("--primary").trim();
		document.documentElement.style.setProperty("--primary", primaryColor);

		if (localStorage.getItem("userData") != undefined) {
			checkactivelogin = true;
		} else {
			checkactivelogin = false;
		}
		document.querySelector("body").classList.add("active-left-panel", "active-modal-loader");
		initiallyLoadTextures();

		if (const_var.crmSetting.parent_api_token == "" || const_var.crmSetting.parent_api_token == undefined) {
			const_var.crmSetting.parent_api_token = const_var.crmSetting.api_token;
		}

		const_var.flag = true;
		let DomainURI = window.location.href.split("#/");

		if (window.location.href.includes("3d-shareable-link") == true && !const_var.is_intel) {
			let splVal = window.location.href.split("3d-shareable-link/");
			if (splVal.length > 0) {
				const_var.crmSetting.is_Edit = true;
				const_var.isKLinkEnable = true;
				dispatch(geDefaultBuildingDataForKlink(splVal));
			}
		} else {
			if (DomainURI?.[0]?.includes("3d_edit")) {
				const_var.is_State_Edit = true;
			}

			if (DomainURI?.length > 1) {
				const_var.crmSetting.is_Edit = true;
				if (const_var.crmSetting.is_Edit) {
					const_var.is_State_Edit = true;
				}
				if (DomainURI[1].includes("is_sensei")) {
					const_var.ishideLeftNevigationBar = true;
					document.querySelector("body").classList.add("active-fullview");
					dispatch(geDefaultBuildingData());
				} else {
					if (const_var.crmSetting.is_Edit) {
						const_var.isKLinkEnable = true;
						dispatch(geDefaultBuildingDataForKlink(DomainURI));
					} else {
						dispatch(getDealerStateList());
					}
				}
			} else {
				if (DomainURI?.[0].includes("3d-public") && !const_var.is_intel) {
					if (const_var.crmSetting.is_Edit == true ) {
						const_var.isPublicModuleID = DomainURI[0].split("3d-public/")[1];
						const_var.isPublicEdit = true;
						const_var.loginSession = false;
						const_var.hideCompareOption = true;
						dispatch(geDefaultBuildingData());
						dispatch(handleShowsummarymodal());
					}
				} else {
					let DomainURI1 = window.location.href.split("?referral_id=");
					let DomainURI11 = window.location.href.split("?pre");
					if (DomainURI11?.length > 1) {
						const_var.crmSetting.header_key = {
							"x-api-key": "Jr9ORHkgSCav399MX0qVj8nkzQXLIw8X4RJCLpUd"
						};
						const_var.crmSetting.api_post_url = "https://crm.senseicrm.com";
						const_var.crmSetting.price_api_url = "https://preapi.senseicrm.com/";
					}
					if (const_var.crmSetting.is_Edit) {
						dispatch(geDefaultBuildingData());
					} else if (const_var.is_intel) {
						const_var.loginSession = false;
						dispatch(getDealerStateList());
						dispatch(getSelectedTabstate("buildingtypetab"));
						dispatch(getPrepareDefaultBuilding());
					} else {
						if (DomainURI1?.length > 1) {
							const_var.referralID = DomainURI1[1];
						}
						if (const_var?.crmSetting?.is_zipcode_screen || (const_var.crmSetting.pre_quote_form && !const_var.loginSession && !const_var.preQuoteError && localStorage.getItem("userData") == null)
						) {
							dispatch(getDealerStateList(true));
						} else {
							dispatch(getDealerStateList());
						}
					}
				}
			}
		}

		if (const_var.isPublicEdit) {
			document.querySelector("html").classList.add("active-customer-edit");
		}
	};
	const didInit = React.useRef(false);
	if (!didInit.current) {
		didInit.current = true;
		initApp();
	}
	useEffect(() => {
		if (const_var.crmSetting.main_domain_url == "prometalbuildings.com") {
			const script = document.createElement("script");
			script.src = window.location.protocol === "https:" ? "https://www.formilla.com/scripts/feedback.js" : "http://www.formilla.com/scripts/feedback.js";
			script.async = true;
			script.onload = () => {
				if (window.Formilla) {
					window.Formilla.guid = "cs7aa066-1592-4540-bf6c-6a9ae6ca7ace";
					window.Formilla.loadWidgets();
				}
			};
			document.head.appendChild(script);
		}

		window.addEventListener("scroll", () => {
			if (window.scrollY >= 1) {
				document.querySelector("body").classList.add("minimal-mode");
			} else {
				document.querySelector("body").classList.remove("minimal-mode");
			}
		});
	}, []);

	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty("--vh", `${vh}px`);
	window.addEventListener("resize", () => {
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${vh}px`);
	});

	const_var.referrer = document.referrer;

	let parentClass = [
		"App",
		const_var.loginSession == true || checkactivelogin == true ? "active-login-session" : "",
		const_var.hide_price_calculation == 1 ? "" : "",
		const_var.isShowCompare == true ? "active-compare-shopping" : "",
		(const_var.user_type_for_comparision == "premium" || const_var.checkUserRole != "") && const_var.crmSetting.is_module_name != "inventory" ? "allow-compare" : "",
		const_var.isShowEditConfigurationButton != true && const_var.crmSetting.is_quote_Edit == true && window.innerWidth > 992 ? "active-fullview active-quote-edit-view" : ""
	];
	parentClass = parentClass.join(" ");

	if (const_var.alertUsedFor == "ManageKlinkExpire") {
		return <MaintenanceWindow />;
	}

	if (const_var.IsMentananceWindow == true) {
		return <MaintenanceWindow />;
	}

	return (
		<div className={parentClass}>
			<UserTour />

			<div className={const_var.crmSetting.is_show_background  || const_var.crmSetting.is_show_background == undefined ? "active-building-bg" : "for-screenshot"}>
				{const_var.crmSetting.is_hide_discount && showDiscountBanners ? <Discounts /> : null}
				{showDiscountBanners && const_var.discount_Offers_end_date == "" && <TopBanner />}

				<DiscountPopUp />

				<div className={const_var.showhideleftpanel ? "active-left-panel" : "active-left-panel"}>
					<Header />
					<MobileHeader />

					<MobilePriceSummary />

					<div className={"main-building-wrapper " + (const_var?.ishideLeftNevigationBar ? "full-width-view" : "")}>
						<div
							data-tut="Thumbnailtour"
							className={`buildcanvas-section ${isMobileDraw && "minimal-mode"}`}
							onClick={(e) => {
								e.stopPropagation();
								if (isMobileDraw) dispatch(handleMobileDraw(false));
							}}
						>
							<NewCanvas />
							<DoorWindowEditComponent />
							<CupolaEditBox />

							{const_var.crmSetting.source !== "https://estimator.warriorbuildings.com/" && !const_var.loginSession && (
								<div className="book-demo-wrapper">
									<AnimButton className={"btn btn-primary book-demo-btn"} event={() => dispatch(handleShowBookDemo())}>
										<i className="icon-phone-ico"></i>
									</AnimButton>
									{isShowBookDemo && !const_var.loginSession && <BookADemoTooltip />}
								</div>
							)}

							<div className="powered-by" onClick={() => window.open("https://www.senseidigital.com/", "_blank")}>
								<span className="text">Powered by - </span>
								<img src={process.env.REACT_APP_BASE_URL + logoSvg} alt="SENSEI logo img" />
							</div>
						</div>

						<div className={`${selectedTabKey == "summary" ? "component-section active-summary-tab" : "component-section"} ${!isMobileDraw && window.innerWidth < 993 && "d-none"}`}>
							<ControlPanel />
						</div>
					</div>

					<StateChange />
					<DeviceCaptureInfo />
					<MobileFooter />

					<div className={const_var.showProcessLoaderchk == true ? " fullpage-loader spinner-loader spinner-active  " : "fullpage-loader spinner-loader "}>
						<div className="spinner-loader">
							<div className="spinner"></div>
						</div>
						<div className="spinner-content">
							<h6>We're generating your order…</h6>
							<p className="barlow-medium">We're capturing your building pictures… You will see a secure checkout form on next screen</p>
						</div>
					</div>

					<div className={const_var.showProcessLoaderchkEdit == true ? " fullpage-loader spinner-loader spinner-active  " : "fullpage-loader spinner-loader "}>
						<div className="spinner-loader">
							<div className="spinner"></div>
						</div>
						<div className="spinner-content">
							<h6>Please wait…</h6>
							<p className="barlow-medium">We're preparing your building</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default App;
